var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnbFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.264 16.5c.49 0 .903.18 1.24.54.336.36.502.78.496 1.26L14.132 21l-5.987-1.8v-8.1h1.668l6.218 2.421c.445.186.667.522.667 1.008 0 .282-.097.528-.29.738-.195.21-.44.321-.736.333h-2.395l-1.497-.603-.282.846 1.779.657h5.987zM15.843 4.107C16.447 3.369 17.217 3 18.152 3c.775 0 1.431.3 1.967.9.536.6.821 1.29.855 2.07 0 .618-.285 1.356-.855 2.214-.57.858-1.132 1.575-1.685 2.151-.553.576-1.417 1.431-2.591 2.565a107.45 107.45 0 01-2.617-2.565c-.56-.576-1.12-1.293-1.685-2.151-.565-.858-.841-1.596-.83-2.214 0-.816.277-1.506.83-2.07a2.9 2.9 0 012.001-.9c.912 0 1.68.369 2.3 1.107zM3 11.1h3.435V21H3v-9.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbFill);
export default __webpack_public_path__ + "cf0496619d221800672b5c555bb16fd4.svg";
export { ForwardRef as ReactComponent };